import React, { useState } from "react";
import { View, StyleSheet, ActivityIndicator } from "react-native";
import { WebView } from "react-native-webview";

const ProfileTermScreen = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  return (
    <View style={styles.screen}>
      <WebView
        style={styles.screen}
        source={{
          uri: "https://www.authentikstudios.com/terms-and-conditions",
        }}
        onLoadEnd={() => {
          setIsLoading(false);
        }}
      />
      {isLoading && (
        <View
          style={{
            ...StyleSheet.absoluteFillObject,
            backgroundColor: "black", // your color
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ActivityIndicator />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: "black",
  },
});

export default ProfileTermScreen;
